import { useCallback } from 'react';
import { type FieldValues, type Path, useFormContext } from 'react-hook-form';
import { useTriggerComputedSync } from './useTriggerComputedSync.ts';

export interface IFieldSetValueOptions {
  shouldDirty?: boolean;
  shouldValidate?: boolean;
  shouldTouch?: boolean;
  /** Se `false`, non triggera il sync dei valori calcolati. Default: `true`. */
  shouldSyncComputedValues?: boolean;
}

/**
 * `setValue` con sync automatico dei computed values.
 * Utilizza `useTriggerComputedSync` per la schedulazione.
 */
export function useFormSetValue<T extends FieldValues>() {
  const methods = useFormContext<T>();
  const triggerSync = useTriggerComputedSync();

  return useCallback(
    (name: Path<T>, value: any, options?: IFieldSetValueOptions) => {
      methods.setValue(name, value, options);
      if (options?.shouldSyncComputedValues !== false) {
        triggerSync({ path: name, value });
      }
    },
    [methods, triggerSync],
  );
}
